/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import MaskedInput from 'react-maskedinput';
import { connect } from 'react-redux';
import { Input, Button } from '../../components';
import { insereDados, clear2to8 } from '../../store/actions/questionario-actions';

function Main(props) {
  const [valid, setValid] = useState({});
  const schema = Yup.object().shape({
    email: Yup.string()
      .min(3, 'O email digitado não é válido.')
      .required('Preencha o email'),
    telefone: Yup.string()
      .min(10, 'O número de telefone não é válido.')
      .required('Preencha o campo de telefone.'),
    cpf: Yup.string()
      .min(10, 'O CPF não é válido.')
      .required('Preencha o cpf'),
    nome: Yup.string()
      .min(2, 'O nome não é válido.')
      .required('Preencha o nome'),
  });
  const onChange = (event) => {
    const { name, value } = event.target;
    props.insereDados(name, value);
  };
  const clear = async () => {
    await props.clear2to8();
  };
  useEffect(() => {
    clear();
    // eslint-disable-next-line
  }, []);
  const goProximaQuestao = (e) => {
    e.preventDefault();
    const dados = {
      nome: props.dados.nome,
      cpf: props.dados.cpf,
      telefone: props.dados.telefone,
      email: props.dados.email,
    };
    schema.validate(dados).then(
      () => {
        props.history.push('/questao31');
      },
    ).catch((err) => {
      setValid(err);
    });
  };

  return (
    <form onSubmit={goProximaQuestao}>
      <h3>2 -Preencha os campos abaixo com as informações solicitadas </h3>
      <span>Nome:</span>
      <br />
      <Input
        value={props.dados.nome}
        type="text"
        name="nome"
        onChange={(event) => { onChange(event); }}
      />

      <br />
      <span>CPF:</span>
      <br />
      <MaskedInput
        mask="111.111.111-11"
        value={props.dados.cpf}
        name="cpf"
        size="20"
        style={{ marginLeft: 10 }}
        onChange={(event) => { onChange(event); }}
      />
      <br />
      <span>Telefone:</span>
      <br />
      <MaskedInput
        mask="(11) 1 1111 1111"
        value={props.dados.telefone}
        name="telefone"
        size="20"
        style={{ marginLeft: 10 }}
        onChange={(event) => { onChange(event); }}
      />
      <br />
      <span>E-mail:</span>
      <br />
      <Input
        value={props.dados.email}
        type="text"
        name="email"
        onChange={(event) => { onChange(event); }}
      />
      <br />
      <span className="worning">{valid.errors && valid.errors[0]}</span><br />
      <Button
        type="button"
        name="proxima"
        onClick={() => props.history.push('/')}
      >QUESTÃO ANTERIOR
      </Button>
      <Button
        type="submit"
        name="proxima"
      >PRÓXIMA QUESTÃO
      </Button>
    </form>
  );
}

const mapStateToProps = state => (
  {
    dados: state.QuestionarioReducers,
  }
);

export default connect(mapStateToProps, { insereDados, clear2to8 })(Main);
